import { createContext, useContext, type ReactNode } from 'react';

export type InventoryModule = 'store' | 'pharmacy';

const InventoryModuleContext = createContext<InventoryModule>('store');

export const InventoryModuleProvider = ({
  module,
  children,
}: {
  module: InventoryModule;
  children: ReactNode;
}) => (
  <InventoryModuleContext.Provider value={module}>
    {children}
  </InventoryModuleContext.Provider>
);

export const useInventoryModule = (): InventoryModule =>
  useContext(InventoryModuleContext);
